import {codeOptions, messageOptions} from 'entities/monitor';

import React from 'react';
import {t} from '@lingui/core/macro';

import ModalBodyWrapper from 'shared/ui/Modal/ModalBodyWrapper';
import FormGroupWithError from 'shared/ui/FormGroup/FormGroupWithError';
import Select from 'shared/ui/Select/Select';
import ModalBlockButton from 'shared/ui/Button/ModalBlockButton/ModalBlockButton';
import AutoSelectDateRangePicker from 'shared/ui/Date/DateRangePickerControlled/AutoSelectDateRangePicker';
import useHttpMonitorFiltersFormLog from 'features/http/model/useHttpMonitorFiltersFormLog';

interface IHttpMonitorFiltersFormLogProps {
    onSuccess: () => void;
    handleClose: () => void;
}

const HttpMonitorFiltersFormLog: React.FC<IHttpMonitorFiltersFormLogProps> = ({onSuccess, handleClose}) => {
    const {
        form,
        minDate,
        defaultDateRange,
        validateDateRange,
        changeTime,
        submit,
    } = useHttpMonitorFiltersFormLog(onSuccess);
    const {control, formState: {errors}, watch} = form;

    return (
        <form onSubmit={submit}>
            <ModalBodyWrapper>
                <FormGroupWithError
                    label={t`Код ответа`}
                >
                    <Select
                        name="code"
                        data={codeOptions}
                        control={control}
                        cleanable
                        searchable
                    />
                </FormGroupWithError>

                <FormGroupWithError
                    label={t`Результат запроса`}
                >
                    <Select
                        name="message"
                        data={messageOptions}
                        control={control}
                        cleanable
                        searchable
                    />
                </FormGroupWithError>

                <FormGroupWithError
                    label={t`Диапазон дат (обязательно, в пределах одних суток)`}
                    error={errors.checkedAt?.message}
                >
                    <AutoSelectDateRangePicker
                        control={control}
                        name="checkedAt"
                        startTimeValue={watch('startTime')}
                        endTimeValue={watch('endTime')}
                        onTimeChange={changeTime}
                        defaultValue={defaultDateRange}
                        cleanable={false}
                        minDate={minDate}
                        rules={{
                            validate: validateDateRange,
                            required: t`Обязательно укажите диапазон дат`,
                        }}
                        shouldDisableDate={(date: Date) => date < minDate}
                        showTimeSelects={true}
                    />
                </FormGroupWithError>

            </ModalBodyWrapper>
            <ModalBlockButton
                primaryButtonText={t`Применить фильтры`}
                primaryButtonType="submit"
                secondaryButtonOnClick={handleClose}
            />
        </form>
    );
};

export default HttpMonitorFiltersFormLog;
